import { CONFERENCE_BASE_URL } from '../BaseUrls';

function Recording(core) {
    this.client = core.client;
}

const baseUrl = `${CONFERENCE_BASE_URL}api/jibri/`;

Object.assign(Recording.prototype, {
    namespace: 'Recording',
    checkStatusQueue(type, headers = {}) {
        return this.client.send('GET', `${baseUrl}status`, {
            'room_token': config.roomToken,
            type,
            username: APP.conference.__getMyUserJid().split('@')[0],
            resource: APP.conference.getMyUserId()
        }, APP.wildixApiMethods.addAccessTokenAuthorization(headers));
    },
    updateStatusQueue(streamId, type, status, headers = {}) {
        return this.client.sendFormData('POST', `${baseUrl}status`, {
            'room_token': config.roomToken,
            type,
            username: APP.conference.__getMyUserJid().split('@')[0],
            resource: APP.conference.getMyUserId(),
            'stream_key': streamId,
            status
        }, APP.wildixApiMethods.addAccessTokenAuthorization(headers));
    },
    deleteRecord(path, headers = {}) {
        return this.client.send('DELETE', `${baseUrl}record`, {
            'room_token': config.roomToken,
            username: APP.conference.__getMyUserJid().split('@')[0],
            resource: APP.conference.getMyUserId(),
            path
        }, APP.wildixApiMethods.addAccessTokenAuthorization(headers));
    }
});

export default Recording;
